import { useEffect, useState } from 'react';
import { resolveCoords } from '../../maps/ilceKoordinatlari';

// Kayıtlı koordinat > mahalle geocode (OSM Nominatim, localStorage önbellekli) > ilçe merkezi
export const useEmlakKonum = (emlak, open) => {
  const [geo, setGeo] = useState(null);
  useEffect(() => {
    if (!open || !emlak) return undefined;
    setGeo(null);
    const fallback = resolveCoords(emlak.enlem, emlak.boylam, emlak.ilce, emlak.id);
    if (fallback && !fallback.approx) {
      setGeo({ lat: fallback.lat, lon: fallback.lon, kind: 'kayit' });
      return undefined;
    }
    let cancelled = false;
    const q = [emlak.mahalle && `${emlak.mahalle} Mahallesi`, emlak.ilce, emlak.il || 'İstanbul', 'Türkiye'].filter(Boolean).join(', ');
    const cacheKey = `geo:${q}`;
    let cached = null;
    try { cached = JSON.parse(localStorage.getItem(cacheKey) || 'null'); } catch { cached = null; }
    if (cached) {
      setGeo({ lat: cached.lat, lon: cached.lon, kind: 'mahalle' });
      return undefined;
    }
    const ilceFallback = () => { if (!cancelled && fallback) setGeo({ lat: fallback.lat, lon: fallback.lon, kind: 'ilce' }); };
    fetch(`https://nominatim.openstreetmap.org/search?format=json&limit=1&accept-language=tr&q=${encodeURIComponent(q)}`)
      .then((r) => r.json())
      .then((d) => {
        if (cancelled) return;
        if (Array.isArray(d) && d[0]) {
          const hit = { lat: parseFloat(d[0].lat), lon: parseFloat(d[0].lon) };
          try { localStorage.setItem(cacheKey, JSON.stringify(hit)); } catch { /* kota dolu */ }
          setGeo({ ...hit, kind: 'mahalle' });
        } else ilceFallback();
      })
      .catch(ilceFallback);
    return () => { cancelled = true; };
  }, [open, emlak]);
  return geo;
};
